import React, { useState } from 'react'
import { withTranslation } from 'react-i18next'
import Header from '../components/Headers/Header'
import CustomLoader from '../components/Loader/CustomLoader'
import { useQuery, gql } from '@apollo/client'
import { getUsers } from '../apollo'
import DataTable from '../components/DataTable'
import orderBy from 'lodash/orderBy'
import SearchBar from '../components/TableHeader/SearchBar'
import { customStyles } from '../utils/tableCustomStyles'
import useGlobalStyles from '../utils/globalStyles'
import { Box, Container } from '@mui/material'
import TableHeader from '../components/TableHeader'

const GET_USERS = gql`
  ${getUsers}
`
const Users = props => {
  const { t } = props

  const [searchQuery, setSearchQuery] = useState('')
  const onChangeSearch = e => setSearchQuery(e.target.value)
  const { data, error: errorQuery, loading: loadingQuery, refetch } = useQuery(
    GET_USERS,
    {
      variables: { page: 0 }
    }
  )
  const columns = [
    {
      name: t('Name'),
      sortable: true,
      selector: 'name'
    },
    {
      name: t('Email'),
      sortable: true,
      selector: 'email',
      cell: row => row.email
    },
    {
      name: t('Phone'),
      sortable: true,
      selector: 'phone',
      cell: row => row.phone
    }
  ]

  const customSort = (rows, field, direction) => {
    const handleField = row => {
      if (row[field]) {
        return row[field].toLowerCase()
      }
      return row[field]
    }

    return orderBy(rows, handleField, direction)
  }

  const handleSort = (column, sortDirection) =>
    console.log(column.selector, sortDirection)

  const regex =
    searchQuery.length > 2 ? new RegExp(searchQuery.toLowerCase(), 'g') : null

  const filtered =
    searchQuery.length < 3
      ? data && data.users
      : data &&
        data.users.filter(user =>
          // Any of these can be missing (e.g. Apple sign-ups without a phone)
          [user.name, user.phone, user.email].some(
            value => value && value.toLowerCase().search(regex) > -1
          )
        )
  const globalClasses = useGlobalStyles()
  return (
    <>
      <Header />
      <Container classNname={globalClasses.flex} fluid>
        {errorQuery ? (
          <span>
            `${t('Error')}! ${errorQuery.message}`
          </span>
        ) : null}
        {loadingQuery ? (
          <CustomLoader />
        ) : (
          <DataTable
            subHeader={true}
            subHeaderComponent={
              <SearchBar
                value={searchQuery}
                onChange={onChangeSearch}
                onClick={() => refetch()}
              />
            }
            title={<TableHeader title={t('Users')} />}
            columns={columns}
            data={filtered}
            pagination
            progressPending={loadingQuery}
            progressComponent={<CustomLoader />}
            onSort={handleSort}
            sortFunction={customSort}
            customStyles={customStyles}
            selectableRows
            paginationIconLastPage=""
            paginationIconFirstPage=""
          />
        )}
      </Container>
    </>
  )
}
export default withTranslation()(Users)
